import React from 'react';
import ActivityLogView from './Components/ActivityLogView';

const ActivityLog = ({ module }) => {
  document.title = module ? `Log Aktivitas — ${module}` : 'Log Aktivitas';
  return <ActivityLogView module={module} />;
};

export default ActivityLog;
